export default __webpack_public_path__ + "static/media/no-image-available.1218438b.jpg";